import { attemptRequest } from 'redux-requests';
import get from 'lodash/get';

import { status, config } from 'src/constants';

const errorPlaceholder = 'Something went wrong';

export const parseJSON = (response) => response.status === 204 ? response.blob() : response.json();

const fireRequest = (url, options) => fetch(url, options).then((response) => {
  if (response.status >= 200 && response.status < 300) {
    return parseJSON(response);
  }

  throw response;
});

const doRequest = (actionType, url, options, meta) => (dispatch) => {
  const { dataPath = ['data'], ...rest } = options;
  const { getSuccessNotificationData, getErrorNotificationData } = meta || {};
  const apiUrl = `${config.serviceUrl}${url}`;

  // attemptRequest does not return the promise it creates so we cannot use await
  // fixed by wrapping it in a promise. This promise is resolved with error or success dispatch
  return new Promise((resolve) => attemptRequest(
    apiUrl,
    {
      begin: () => ({
        type: `${actionType}_${status.PENDING}`
      }),
      success: (response) => ({
        type: `${actionType}_${status.SUCCESS}`,
        response,
        dataPath,
        notificationData:
          getSuccessNotificationData &&
          getSuccessNotificationData(get(response, dataPath))
      }),
      failure: (errorResponse) => ({
        type: `${actionType}_${status.ERROR}`,
        error: errorResponse.statusText || errorPlaceholder,
        response: errorResponse,
        errorStatus: errorResponse.status,
        notificationData:
          getErrorNotificationData && getErrorNotificationData(errorResponse)
      })
    },
    () => fireRequest(apiUrl, rest),
    (action) => {
      const result = dispatch(action);

      if (!action.type.includes(status.PENDING)) {
        // promise is resolved after we dispatched the success or error action created
        // via attemtpRequest
        return resolve(result?.response || result);
      }

      return result;
    }
  ));
};

export default doRequest;
